'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { GRACE_PERIOD_MS } from './constants';
import { ExitIntentModal } from './ExitIntentModal';
import { hasWarmedUp, markWarmedUp } from './utils/session';
export function ExitIntentHost() {
  const $ = _c(3);
  const [isWarm, setIsWarm] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (hasWarmedUp()) {
        setIsWarm(true);
        return;
      }
      markWarmedUp();
      const timeoutId = setTimeout(() => setIsWarm(true), GRACE_PERIOD_MS);
      return () => clearTimeout(timeoutId);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!isWarm) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ExitIntentModal />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}